module.exports = __webpack_public_path__ + "img/vertical_7_7_8011.d8899c6f.png";